import type { Dispatch } from '@reduxjs/toolkit';
import { PAYMENT_GATEWAY_PROPERTY } from '../core/constants';
import { setEventData } from '../core/store/events';
import { setAmplitudeUserProperties } from './amplitude';

export const trackPaymentGateway = (dispatch: Dispatch, gateway: string) => {
  setAmplitudeUserProperties({ [PAYMENT_GATEWAY_PROPERTY]: gateway });
  dispatch(setEventData({ [PAYMENT_GATEWAY_PROPERTY]: gateway }));
  return gateway;
};
